var $976ae42272d00bec$exports = {};
$976ae42272d00bec$exports = {
    "valid": `\u{388}\u{3B3}\u{3BA}\u{3C5}\u{3C1}\u{3BF}`
};


export {$976ae42272d00bec$exports as default};
//# sourceMappingURL=el-GR.mjs.map
